import global from './globals';
import creator from './elementCreator';
import TileGrid from 'ol/tilegrid/TileGrid.js';
import {Group, Tile} from 'ol/layer.js';
import WMTS from 'ol/source/WMTS.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import TileWMS from 'ol/source/TileWMS.js';
import Image from 'ol/layer/Image.js';
import ImageWMS from 'ol/source/ImageWMS.js';
import Vector from 'ol/layer/Vector.js';
import VectorWMS from 'ol/source/Vector.js';
import Cluster from 'ol/source/Cluster.js';
import Style from 'ol/style/Style.js';
import Stroke from 'ol/style/Stroke.js';
import Fill from 'ol/style/Fill.js';
import Text from 'ol/style/Text.js';
import Circle from 'ol/style/Circle.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import {bbox, all} from 'ol/loadingstrategy';
import Overlay from 'ol/Overlay.js';

"use strict";
var privateFns;
privateFns = {
	tileGrid: {},
	getLayerLoader: function (id) {
		return $("#" + id).next().find(".layerloader");
	},
	toggleMapMarker: function (e) {
		if (e.type === "addfeature") {
			$("#map-marker").show();
		} else {
			$("#map-marker").hide();
		}
	},
	appendContextLayerLoader: function (target) {
		if (target.parent().find(".context-layer-loader").length === 0) {
			var span = creator.createSpan({css: "context-layer-loader", text: "<i class='layerloader fa fa-spinner fa-pulse'></i> laster.."});
			target.parent().append(span);
		}
	},
	removeContextLayerLoader: function (target) {
		target.parent().find(".context-layer-loader").remove();
	},
	wmsLoadEventFunction: function (parentId, layerId, imageLayer) {
		return function (e) {
			var id = "", contextLoaderId = "";
			if (global.map.getLayerById(parentId) && global.map.getLayerById(parentId).get("groupCheckbox")) {
				id = parentId;
			} else {
				id = layerId;
			}

			if (layerId === "regv2") {
				contextLoaderId = "reg";
			} else if (layerId.indexOf("gl_") >= 0) {
				contextLoaderId = "gulliste";
			} else {
				contextLoaderId = layerId;
			}

			var loader = privateFns.getLayerLoader(id);
			if (e.type === "imageloadstart" || e.type === "tileloadstart") {
				loader.css("display", "inline-block");

				privateFns.appendContextLayerLoader($("#eie-content-show-" + contextLoaderId));
				privateFns.appendContextLayerLoader($("#punkt-content-show-" + contextLoaderId));
				imageLayer.set("loadingTiles", imageLayer.get("loadingTiles") + 1);
			} else {
				imageLayer.set("loadingTiles", imageLayer.get("loadingTiles") - 1);
				if (imageLayer.get("loadingTiles") === 0) {
					loader.css("display", "none");
					privateFns.removeContextLayerLoader($("#eie-content-show-" + contextLoaderId));
					privateFns.removeContextLayerLoader($("#punkt-content-show-" + contextLoaderId));
				}
				if (imageLayer.get("loadingTiles") < 0) {
					console.error("krise!");
				}
			}
		};
	},
	removeSelectedFeatures: function () {
		global.map.getInteractions().forEach(function (interaction) {
			if (interaction.get("interactionId") === "featurehover" || interaction.get("interactionId") === "featureclick") {
				interaction.getFeatures().clear();
			}
		});
	},
	onVectorLoad: function (source, loader) {
		var f = new GeoJSON();
		source.clear();
		return function (r) {
			loader.css("display", "none");
			source.addFeatures(f.readFeatures(r));
		};
	},
	onVectorLoadFail: function (loader) {
		return function (r) {
			loader.css("display", "none");
			loader.prevObject[0].insertAdjacentHTML("beforeend","<i title='Kartlaget feilet' class='fa fa-exclamation-triangle'></i>");
			loader.prevObject[0].style.color = "red";
			console.error(r);
		};
	},
	setRadiusForSize: function (size) {
		var returnSize = size;
		if (size < 9) {
			returnSize = 9;
		} else if (size > 40) {
			returnSize = 30;
		}
		return returnSize;
	},
	addMarkerlayerGroup: function (layers) {
		var group = new Group({
			layerId: "mapmarkers",
			displayInLayerMenu: false,
			layers: []
		});
		var markerlayer = new Vector({
			layerId: "markers",
			displayInLayerMenu: false,
			source: new VectorWMS({features: []}),
			opacity: 0.9,
			style: new Style({
				stroke: new Stroke({
					color: "#3366ff",
					width: 6
				}),
				fill: new Fill({
					color: "rgba(179, 198, 255, 0.3)"
				})
			})
		});
		group.getLayers().push(markerlayer);
		markerlayer.getSource().on("addfeature", privateFns.toggleMapMarker);
		markerlayer.getSource().on("removefeature", privateFns.toggleMapMarker);

		var fontmarkerlayer = new Vector({
			layerId: "fontmarkers",
			displayInLayerMenu: false,
			source: new VectorWMS({features: []}),
			opacity: 0.9,
			style: new Style({
				text: new Text({
					text: "\ue062",
					font: "normal 40px Glyphicons Halflings",
					textBaseline: "Bottom",
					fill: new Fill({
						color: "#3366ff"
					})
				})
			})
		});
		group.getLayers().push(fontmarkerlayer);
		fontmarkerlayer.getSource().on("addfeature", privateFns.toggleMapMarker);
		fontmarkerlayer.getSource().on("removefeature", privateFns.toggleMapMarker);

		group.getLayers().push(new Vector({
			layerId: "hoverhighlight",
			displayInLayerMenu: false,
			source: new VectorWMS({features: []}),
			opacity: 0.9,
			style: function (feature) {
				var fillColor;
				if (feature.get("FORMAAL") === "Områdeavgrensning for indre Oslo" || feature.get("FORMAAL") === "Sentrumsområdet") {
					fillColor = "rgba(175, 100, 75, 0.2)";
				} else {
					fillColor = "rgba(175, 100, 75, 0.8)";
				}

				return new Style({
					fill: new Fill({
						color: fillColor
					}),
					stroke: new Stroke({
						color: "rgba(175, 100, 75, 1)",
						width: 4
					}),
					image: new Circle({
						radius: 7,
						fill: new Fill({
							color: "rgba(175, 100, 75, 1)"
						}),
						snapToPixel: true
					})
				});
			}
		}));
		group.getLayers().push(new Vector({
			layerId: "searchhighlight",
			displayInLayerMenu: false,
			source: new VectorWMS({features: []}),
			opacity: 0.9,
			style: new Style({
				fill: new Fill({
					color: "rgba(0, 255, 255, 0.75)"
				}),
				stroke: new Stroke({
					color: "rgba(0, 255, 255, 0.75)",
					width: 4
				})
			})
		}));

		return group;
	},
	createTileLayerFromConfig: function (lyrParams, parentId) {
		lyrParams.parentId = parentId;

		if (lyrParams.visible === undefined) {
			lyrParams.visible = true;
		}
		if (lyrParams.displayInLayerMenu === undefined) {
			lyrParams.displayInLayerMenu = true;
		}
		var layer = new Tile({
			title: lyrParams.title,
			layerId: lyrParams.layerId,
			displayInLayerMenu: lyrParams.displayInLayerMenu,
			layerInfo: lyrParams.layerInfo || false,
			customLayerInfo: lyrParams.customLayerInfo || false,
			dontCascade: lyrParams.dontCascade || false,
			attribution: lyrParams.attribution || null,
			attributionId: lyrParams.attributionId || null,
			dependent: lyrParams.dependent || null,
			exclude: lyrParams.exclude || null,
			conditional: lyrParams.conditional || null,
			radio: lyrParams.radio,
			noToggle: lyrParams.noToggle || false,
			hiddenToggle: lyrParams.hiddenToggle || false,
			loadingTiles: 0,
			source: new TileWMS({
				url: lyrParams.url,
				params: {"LAYERS": lyrParams.layerName, "SRS": lyrParams.epsg || "EPSG:4326"},
				pixelRatio: 1,
				tileGrid: privateFns.tileGrid
			}),
			visible: lyrParams.visible
		});

		if (lyrParams.altSource) {
			layer.set("altSource", new TileWMS({
				url: lyrParams.altSource.url,
				params: {"LAYERS": lyrParams.altSource.layerName, "SRS": lyrParams.altSource.epsg || "EPSG:4326"},
				pixelRatio: 1,
				//tileGrid: privateFns.tileGrid
				tileGrid: new TileGrid({
					origin: global.origin,
					resolutions: global.mapresolutionsExt,
					tileSize: [1024, 1024]
				})
			}));
		}

		layer.getSource().on("tileloadstart", privateFns.wmsLoadEventFunction(lyrParams.parentId, lyrParams.layerId, layer));
		layer.getSource().on("tileloadend", privateFns.wmsLoadEventFunction(lyrParams.parentId, lyrParams.layerId, layer));
		return layer;
	},
	createImageLayerFromConfig: function (lyrParams, parentId) {
		if (lyrParams.visible === undefined) {
			lyrParams.visible = true;
		}
		if (lyrParams.displayInLayerMenu === undefined) {
			lyrParams.displayInLayerMenu = true;
		}
		var layer = new Image({
			title: lyrParams.title,
			layerId: lyrParams.layerId,
			displayInLayerMenu: lyrParams.displayInLayerMenu,
			layerInfo: lyrParams.layerInfo || false,
			customLayerInfo: lyrParams.customLayerInfo || false,
			attribution: lyrParams.attribution || null,
			attributionId: lyrParams.attributionId || null,
			dependent: lyrParams.dependent || null,
			exclude: lyrParams.exclude || null,
			conditional: lyrParams.conditional || null,
			dontCascade: lyrParams.dontCascade || false,
			zIndex: lyrParams.zIndex || null,
			radio: lyrParams.radio,
			noToggle: lyrParams.noToggle || false,
			hiddenToggle: lyrParams.hiddenToggle || false,
			opacity: lyrParams.opacity || 1,
			preload: 6,
			loadingTiles: 0,
			source: new ImageWMS({
				url: lyrParams.url,
				params: {"LAYERS": lyrParams.layerName, "SRS": lyrParams.epsg || "EPSG:4326", "FORMAT": lyrParams.format || "image/png", "TRANSPARENT": "true"}
			}),
			visible: lyrParams.visible
		});
		layer.getSource().on("imageloadstart", privateFns.wmsLoadEventFunction(parentId, lyrParams.layerId, layer));
		layer.getSource().on("imageloadend", privateFns.wmsLoadEventFunction(parentId, lyrParams.layerId, layer));
		return layer;
	},
	createVectorSourceFromConfig: function (lyrParams) {
		var source;
		if (lyrParams.url) {
			source = new VectorWMS({
				loader: function (extent) {
					var url = lyrParams.url + "&typename=" + lyrParams.typeName + "&outputformat=geojson&srs=EPSG:4326";
					if(lyrParams.filter){
						url = url + lyrParams.filter;
					}else{							
						url = url + "&bbox=" + extent.join(",");
					}
					var loaderEl = privateFns.getLayerLoader(lyrParams.layerId);
					loaderEl.css("display", "inline-block");

					$.ajax({
						url: url,
						dataType: "json",
						jsonp: false,
						success: privateFns.onVectorLoad(source, loaderEl),
						fail: privateFns.onVectorLoadFail(loaderEl),
						error: privateFns.onVectorLoadFail(loaderEl)
					});
				},
				strategy: bbox
				/*strategy: ol.loadingstrategy.tile(
				 ol.tilegrid.createXYZ({maxZoom: 9})
				 )*/
			});
			source.set("baseUrl", lyrParams.url);
		} else {
			source = new ol.source.Vector({features: []});
		}

		return source;
	},
	createEsriVectorSourceFromConfig: function (lyrParams) {
	   var source;
		if (lyrParams.url) {
			source = new ol.source.Vector({
				format: new ol.format.EsriJSON(),
				url: function (extent, resolution, projection) {
					// ArcGIS Server only wants the numeric portion of the projection ID.
					const srid = 4326;
					const url =
					  lyrParams.url +
					  '/2/query?f=json&' +
					  'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
					  encodeURIComponent(
						  '{"xmin":' + extent[0] +
						  ',"ymin":' + extent[1] +
						  ',"xmax":' + extent[2] +
						  ',"ymax":' + extent[3] +
						  ',"spatialReferance":{"wkid":4326}}'
						  
					  ) +
					  '&geometryType=esriGeometryEnvelope&inSR=' +
					  srid +
					  '&outSR=' + srid;
					return url;
				},
				strategy: bbox
			});
			source.set("baseUrl", lyrParams.url);
		} else {
			source = new VectorWMS({features: []});
		}
		return source;
	},
	createCalendarVectorSourceFromConfig: function (lyrParams) {
		var source = new VectorWMS({
			loader: function () {
				var fromDateInput = $("#" + lyrParams.layerId + "-from-date");
				var lowerDateStr = "", upperDateStr = "", lowerDate, upperDate;
				if (fromDateInput.datepicker("getDate")) {
					lowerDateStr = $.datepicker.formatDate("yymmdd", fromDateInput.datepicker("getDate"));
				} else {
					lowerDate = new Date();
					lowerDate.setDate(lowerDate.getDate() - 9);
					lowerDateStr = $.datepicker.formatDate("yymmdd", lowerDate);
				}

				var toDateInput = $("#" + lyrParams.layerId + "-to-date");
				if (toDateInput.datepicker("getDate")) {
					upperDateStr = $.datepicker.formatDate("yymmdd", toDateInput.datepicker("getDate"));
				} else {
					upperDate = new Date();
					upperDate.setDate(upperDate.getDate() - 2);
					upperDateStr = $.datepicker.formatDate("yymmdd", upperDate);
				}
				var url = lyrParams.url + "&typename=" + lyrParams.typeName +
						"&outputformat=geojson&srs=EPSG:4326&" +
						"Filter=<Filter><PropertyIsBetween><PropertyName>D</PropertyName>";
				url += "<LowerBoundary>" + lowerDateStr + "</LowerBoundary>";
				url += "<UpperBoundary>" + upperDateStr + "</UpperBoundary></PropertyIsBetween>";
				url += "</Filter>";
				var loaderEl = privateFns.getLayerLoader(lyrParams.layerId);
				loaderEl.css("display", "inline-block");

				$.ajax({
					url: url,
					dataType: "json",
					jsonp: true,
					success: function (r) {
						var f = new GeoJSON();
						loaderEl.hide();
						var features = f.readFeatures(r);
						source.addFeatures(features);
						$("#" + lyrParams.layerId + "-kalender").find(".calendar-count").html("<p>Antall dokumenter: " + features.length + "</p>");
					},
					fail: privateFns.onVectorLoadFail(loaderEl),
					error: privateFns.onVectorLoadFail(loaderEl)
				});
			},
			strategy: all
		});
		source.set("baseUrl", lyrParams.url);
		return source;
	},
	createVectorLayerFromConfig: function (lyrParams) {
		if (lyrParams.visible === undefined) {
			lyrParams.visible = true;
		}
		if (lyrParams.displayInLayerMenu === undefined) {
			lyrParams.displayInLayerMenu = true;
		}
		var source = privateFns.createVectorSourceFromConfig(lyrParams);
		var opacity = 1;
		
		var style = function (feature) {
			feature.set('layerName', lyrParams.layerId);
			var color = "";
			if (lyrParams.fillColorAlt && lyrParams.attribute) {
				if (feature.get(lyrParams.attribute) === lyrParams.featureAttribute) {
					color = lyrParams.fillColorAlt;
				} else {
					if(typeof lyrParams.fillColor === "object"){	
						color = lyrParams.fillColor[feature.get(lyrParams.fillColor.comparator)];
					}else{
						color = lyrParams.fillColor;
					}
				}
			}else{
				if(typeof lyrParams.fillColor === "object"){	
					color = lyrParams.fillColor[feature.get(lyrParams.fillColor.comparator)];
				}else{
					color = lyrParams.fillColor;
				}
			}
			var style = "";
			if(lyrParams.drawType === "stroke"){
				return new Style({
					stroke: new Stroke({
						color: color,
						width: 15,
					})
				});
			}else if(lyrParams.drawType === "stipletfyll"){
				return new Style({
					fill: new Fill({
						color: color
					}),
					stroke: new Stroke({
						color: '#000000',
						lineDash:[20,10],
						width: 5
					})
				});
				opacity = lyrParams.opacity || 0.5;
			}else{
				return new Style({
					fill: new Fill({
						color: color
					}),
					stroke: new Stroke({
						color: '#000000',
						width: 1,
					}),
					image: new Circle({
						radius: 7,
						fill: new Fill({
							color: color
						}),
						snapToPixel: true
					})
				});
				opacity = lyrParams.opacity || 0.5;
			}
		};

		return new Vector({
			title: lyrParams.title,
			layerId: lyrParams.layerId,
			layerInfo: lyrParams.layerInfo,
			customLayerInfo: lyrParams.customLayerInfo || false,
			attribution: lyrParams.attribution || null,
			attributionId: lyrParams.attributionId || null,
			dependent: lyrParams.dependent || null,
			exclude: lyrParams.exclude || null,
			conditional: lyrParams.conditional || null,
			dontCascade: lyrParams.dontCascade || false,
			radio: lyrParams.radio,
			displayInLayerMenu: lyrParams.displayInLayerMenu,
			noToggle: lyrParams.noToggle || false,
			hiddenToggle: lyrParams.hiddenToggle || false,
			featureInfo: lyrParams.featureInfo,
			source: source,
			style: style,
			//style_:style,
			opacity: opacity,
			visible: lyrParams.visible,
			zIndex: lyrParams.zIndex || null,
		});
	},
	createEsriVectorLayerFromConfig: function (lyrParams) {
		if (lyrParams.visible === undefined) {
			lyrParams.visible = true;
		}
		if (lyrParams.displayInLayerMenu === undefined) {
			lyrParams.displayInLayerMenu = true;
		}
		var source = privateFns.createEsriVectorSourceFromConfig(lyrParams);
		var opacity = 1;
		
		var style = function (feature) {
			feature.set('layerName', lyrParams.layerId);
			var color = "";
			if (lyrParams.fillColorAlt && lyrParams.attribute) {
				if (feature.get(lyrParams.attribute) === lyrParams.featureAttribute) {
					color = lyrParams.fillColorAlt;
				} else {
					if(typeof lyrParams.fillColor === "object"){	
						color = lyrParams.fillColor[feature.get(lyrParams.fillColor.comparator)];
					}else{
						color = lyrParams.fillColor;
					}
				}
			}else{
				if(typeof lyrParams.fillColor === "object"){	
					color = lyrParams.fillColor[feature.get(lyrParams.fillColor.comparator)];
				}else{
					color = lyrParams.fillColor;
				}
			}
			var style = "";
			if(lyrParams.drawType === "stroke"){
				return new ol.style.Style({
					stroke: new ol.style.Stroke({
						color: color,
						width: 15,
					})
				});
			}else if(lyrParams.drawType === "stipletfyll"){
				return new ol.style.Style({
					fill: new ol.style.Fill({
						color: color
					}),
					stroke: new ol.style.Stroke({
						color: '#000000',
						lineDash:[20,10],
						width: 5
					})
				});
				opacity = lyrParams.opacity || 0.5;
			}else{
				return new ol.style.Style({
					fill: new ol.style.Fill({
						color: color
					}),
					stroke: new ol.style.Stroke({
						color: '#000000',
						width: 1,
					}),
					image: new ol.style.Circle({
						radius: 7,
						fill: new ol.style.Fill({
							color: color
						}),
						snapToPixel: true
					})
				});
				opacity = lyrParams.opacity || 0.5;
			}
		};

		return new Vector({
			title: lyrParams.title,
			layerId: lyrParams.layerId,
			layerInfo: lyrParams.layerInfo,
			customLayerInfo: lyrParams.customLayerInfo || false,
			attribution: lyrParams.attribution || null,
			attributionId: lyrParams.attributionId || null,
			dependent: lyrParams.dependent || null,
			exclude: lyrParams.exclude || null,
			conditional: lyrParams.conditional || null,
			dontCascade: lyrParams.dontCascade || false,
			radio: lyrParams.radio,
			displayInLayerMenu: lyrParams.displayInLayerMenu,
			noToggle: lyrParams.noToggle || false,
			hiddenToggle: lyrParams.hiddenToggle || false,
			featureInfo: lyrParams.featureInfo,
			source: source,
			style: style,
			opacity: opacity,
			visible: lyrParams.visible,
			zIndex: lyrParams.zIndex || null,
		});
	},
	addClusteredLayerFromConfig: function (lyrParams, source, styleCache) {
		if (lyrParams.visible === undefined) {
			lyrParams.visible = true;
		}
		if (lyrParams.displayInLayerMenu === undefined) {
			lyrParams.displayInLayerMenu = true;
		}
		var layer = new Vector({
			title: lyrParams.title,
			layerId: lyrParams.layerId,
			layerInfo: lyrParams.layerInfo,
			customLayerInfo: lyrParams.customLayerInfo || false,
			attribution: lyrParams.attribution || null,
			attributionId: lyrParams.attributionId || null,
			dependent: lyrParams.dependent || null,
			exclude: lyrParams.exclude || null,
			conditional: lyrParams.conditional || null,
			dontCascade: lyrParams.dontCascade || false,
			radio: lyrParams.radio,
			displayInLayerMenu: lyrParams.displayInLayerMenu,
			featureInfo: lyrParams.featureInfo,
			calendar: lyrParams.calendar,
			maxDateTo: lyrParams.maxDate,
			minDateFrom: lyrParams.minDate,
			noToggle: lyrParams.noToggle || false,
			hiddenToggle: lyrParams.hiddenToggle || false,
			source: new Cluster({
				distance: 30,
				source: source
			}),
			style: function (feature) {
				var size = feature.get("features").length;
				var style = styleCache[size];
				var radius = privateFns.setRadiusForSize(size);
				if (!style) {
					style = [new Style({
						image: new Circle({
							radius: radius,
							fill: new Fill({
								color: lyrParams.fillColor
							}),
							snapToPixel: true
						}),
						text: new Text({
							text: size.toString(),
							fill: new Fill({
								color: lyrParams.textColor
							})
						})
					})];
					styleCache[size] = style;
				}
				return style;
			},
			visible: false
		});
		layer.on("change:visible", privateFns.removeSelectedFeatures);

		return layer;
	},
	createClusterLayerFromConfig: function (lyrParams) {
		var source;
		var styleCache = {};
		if (lyrParams.calendar) {
			source = privateFns.createCalendarVectorSourceFromConfig(lyrParams);
		} else {
			source = privateFns.createVectorSourceFromConfig(lyrParams);
		}
		return privateFns.addClusteredLayerFromConfig(lyrParams, source, styleCache);
	},
	createWMTSLayerFromConfig: function (lyrParams, parentId) {
		lyrParams.parentId = parentId;

		if(lyrParams.visible){
			//global.defaults.push(lyrParams.layerId);
		}
		if (lyrParams.visible === undefined) {
			lyrParams.visible = true;
		}
		if (lyrParams.displayInLayerMenu === undefined) {
			lyrParams.displayInLayerMenu = true;
		}
		var layer = new Tile({
			title: lyrParams.title,
			layerId: lyrParams.layerId,
			displayInLayerMenu: lyrParams.displayInLayerMenu,
			layerInfo: lyrParams.layerInfo || false,
			customLayerInfo: lyrParams.customLayerInfo || false,
			attribution: lyrParams.attribution || null,
			attributionId: lyrParams.attributionId || null,
			dependent: lyrParams.dependent || null,
			exclude: lyrParams.exclude || null,
			conditional: lyrParams.conditional || null,
			dontCascade: lyrParams.dontCascade || false,
			radio: lyrParams.radio,
			loadingTiles: 0,
			noToggle: lyrParams.noToggle || false,
			hiddenToggle: lyrParams.hiddenToggle || false,
			source: new WMTS({
				url: lyrParams.url,
				layer: lyrParams.layerName,
				matrixSet: "EUREF89",
				format: "image/png",
				projection: "EPSG:32632",
				tileGrid: new WMTSTileGrid({
					origins: [[567000, 6687733.2992], [567000, 6680959.96928], [567000, 6685023.97952], [567000, 6682314.64704], [567000, 6680959.96928], [567000, 6680282.636288], [567000, 6680282.81856], [567000, 6680113.4848], [567000, 6680011.703091], [567000, 6680011.707628]],
					resolutions: [66.1458, 39.68748000000001, 21.16666, 10.58333, 5.291664, 2.645832, 1.32292, 0.66146, 0.2645832, 0.13229161],
					matrixIds: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]
				}),
				style: "default",
				wrapX: undefined
			}),
			visible: lyrParams.visible
		});
		if (lyrParams.altSource) {
			layer.set("altSource", new TileWMS({
				url: lyrParams.altSource.url,
				params: {"LAYERS": lyrParams.altSource.layerName, "SRS": lyrParams.altSource.epsg || "EPSG:4326"},
				pixelRatio: 1,
				//tileGrid: privateFns.tileGrid
				tileGrid: new TileGrid({
					origin: global.origin,
					resolutions: global.mapresolutionsExt,
					tileSize: [1024, 1024]
				})
			}));
		}

		layer.getSource().on("tileloadstart", privateFns.wmsLoadEventFunction(lyrParams.parentId, lyrParams.layerId, layer));
		layer.getSource().on("tileloadend", privateFns.wmsLoadEventFunction(lyrParams.parentId, lyrParams.layerId, layer));
		return layer;
	},
	createLayerGroup: function (lyrParams) {
		if (lyrParams.visible === undefined) {
			lyrParams.visible = true;
		}
		if (lyrParams.displayInLayerMenu === undefined) {
			lyrParams.displayInLayerMenu = true;
		}
	var layerGroup = new Group({
			title: lyrParams.title,
			layerId: lyrParams.layerId || null,
			groupCheckbox: lyrParams.groupCheckbox || false,
			layerInfo: lyrParams.layerInfo || false,
			customLayerInfo: lyrParams.customLayerInfo || false,
			attribution: lyrParams.attribution || null,
			attributionId: lyrParams.attributionId || null,
			dontCascade: lyrParams.dontCascade || false,
			radio: lyrParams.radio,
			displayInLayerMenu: lyrParams.displayInLayerMenu,
			altTarget: lyrParams.altTarget || false,
			collapsible: lyrParams.collapsible,
			loadingTiles: 0,
			indeterminate: lyrParams.indeterminate || false,
			noToggle: lyrParams.noToggle || false,
			hiddenToggle: lyrParams.hiddenToggle || false,
			visible: lyrParams.visible
		});
		return layerGroup;
	},
	addLayersFromConfig: function (parent, lyr) {
		var layer = undefined, ok = true;
		if(lyr.default){
			global.defaults.push(lyr.layerId);
		}
		if (lyr.olType === "group") {
			layer = privateFns.createLayerGroup(lyr);
			if (lyr.layers.length > 0) {
				lyr.layers.forEach(function (l) {
					privateFns.addLayersFromConfig(layer, l);
				});
			}
		} else if (lyr.olType === "tile") {
			layer = privateFns.createTileLayerFromConfig(lyr, parent.get("layerId"));
		} else if (lyr.olType === "image") {
			layer = privateFns.createImageLayerFromConfig(lyr, parent.get("layerId"));
		} else if (lyr.olType === "vector") {
			layer = privateFns.createVectorLayerFromConfig(lyr);
		} else if (lyr.olType === "esrivector") {
			layer = privateFns.createEsriVectorLayerFromConfig(lyr);
		} else if (lyr.olType === "cluster") {
			layer = privateFns.createClusterLayerFromConfig(lyr);
		} else if (lyr.olType === "wmts") {
			layer = privateFns.createWMTSLayerFromConfig(lyr, parent.get("layerId"));
		} else {
			console.log("false");
			ok = false;
		}
		if (ok) {
			layer.set("parentId", parent.get("layerId"));
			parent.getLayers().push(layer);
		}
	}
};

export default {
	addLayers: function (layers) {
		privateFns.tileGrid = new TileGrid({origin: global.origin, resolutions: global.mapresolutionsExt});

		layers.forEach(function (lyr) {
			privateFns.addLayersFromConfig(global.map, lyr);
		});
		global.map.addLayer(privateFns.addMarkerlayerGroup(layers));
	},
	addPopupOverlay: function (){
		/* Legger til overlay for å vise popups */
		global.map.addOverlay(new Overlay({
			element: document.getElementById("popup"),
			autoPan: false,
			autoPanAnimation: {
				duration: 250
			}
		}));
		$("#popup").show();
	},
	setRadiusForSize: privateFns.setRadiusForSize
};
